export const MARKER_WIDTH_METERS = 10;
export const MARKER_TEXTURE_WIDTH = 128;
export const MARKER_TEXTURE_HEIGHT = 128;
export const ICON_CENTER_Y = 64;
export const ICON_CENTER_X = MARKER_TEXTURE_WIDTH / 2;
export const ICON_RADIUS = 48;
export const ICON_STROKE_WIDTH = 5;
export const ICON_PATH_SCALE = 2;
export const ICON_SHADOW_COLOR = "#18233d";
export const ICON_SHADOW_BLUR = 2;
export const MARKER_POLE_HEIGHT = 12;
// 가까이 가도 2D 지도 핀(32px) 정도에서 멈춘다 — 장비가 빽빽할 때 서로 덮지 않게.
const MAX_ICON_PIXELS = 30;
export const LABEL_SHOW_ICON_PIXELS = 24;
export const LABEL_HIDE_ICON_PIXELS = 20;
export function trimmedPoleHeight(
  screenLength: number,
  clearance: number,
  baseDepth: number,
  tipDepth: number,
  poleHeight = MARKER_POLE_HEIGHT
) {
  if (screenLength <= clearance || baseDepth <= 0 || tipDepth <= 0) return 0;
  const fraction = 1 - clearance / screenLength;
  return (poleHeight * fraction * baseDepth) / (tipDepth * (1 - fraction) + fraction * baseDepth);
}
/** 고도 없는 핀의 기둥이 화면에서 유지하는 길이(px) */
const STEM_PIXELS = 36;
/**
 * 지금 그릴 기둥 길이(m). 기둥은 장비 점에서 아이콘을 띄우는 받침일 뿐이라 화면에서 일정한
 * 길이가 되게 줄인다 — 가까이 가면 12m 기둥이 화면을 가로지른다.
 */
export function stemHeight(depth: number, projectionY: number, viewportHeight: number) {
  if (depth <= 0 || projectionY <= 0 || viewportHeight <= 0) return MARKER_POLE_HEIGHT;
  const pixelsPerMeter = (projectionY * viewportHeight) / (2 * depth);
  return Math.min(MARKER_POLE_HEIGHT, Math.max(1.5, STEM_PIXELS / pixelsPerMeter));
}
export function markerDimensions(depth: number, projectionY: number, viewportHeight: number) {
  if (depth <= 0 || projectionY <= 0 || viewportHeight <= 0) return null;
  const pixelsPerMeter = (projectionY * viewportHeight) / (2 * depth);
  const iconRatio = (2 * ICON_RADIUS) / MARKER_TEXTURE_WIDTH;
  const width = Math.min(MARKER_WIDTH_METERS, MAX_ICON_PIXELS / (pixelsPerMeter * iconRatio));
  const height = (width * MARKER_TEXTURE_HEIGHT) / MARKER_TEXTURE_WIDTH;
  return {
    width,
    height,
    iconPixels: width * pixelsPerMeter * iconRatio,
  };
}
